<template>
<div>
    <md-button class="md-icon-button md-raised" v-bind:disabled="!canPageDown" v-on:click="pageDown"><md-icon>keyboard_arrow_left</md-icon></md-button>
<!--     <md-input-container>
        <md-input v-model="page" type="number" @change="setPage" :max="totalPages" :min="1"></md-input>
    </md-input-container> -->
    <div class="page-number-container">
        <input type="text" v-model="page" class="current-page-input" />
        /{{totalPages}}
    </div>
    <md-button class="md-icon-button md-raised" v-bind:disabled="!canPageUp" v-on:click="pageUp"><md-icon>keyboard_arrow_right</md-icon></md-button>
</div>
</template>

<script>

const handleKeyDown = function(that, e) {
    const preventTargets = ['md-input'];
    if (e.target.className.split(' ').some((el) => { return preventTargets.some((prevent) => { return el === prevent; }); })) return;
    if (e.key === 'ArrowLeft') {
        that.pageDown();
    }
    if (e.key === 'ArrowRight') {
        that.pageUp();
    }
};
/**
 * Component For...
 */
const ProjectPagination = {
    name: 'projectPagination',
    props: [
        'totalPages',
        'currentPage'
    ],
    data: function() {
        return {
            page: this.$props.currentPage
        };
    },
    watch: {
        page() {
            this.setPage();
        }
    },
    computed: {
        canPageDown() {
            if (this.page > 1) {
                return true;
            }
            return false;
        },
        canPageUp() {
            if (this.page < this.totalPages) {
                return true;
            }
            return false;
        }
    },
    methods: {
        pageDown() {
            if (this.canPageDown) {
                // console.log('page down');
                // this.$emit('pageDown', this.page);
                this.page = Math.max(1, this.page - 1);
                // this.$emit('setPage', this.page);
            }
        },
        pageUp() {
            if (this.canPageUp) {
                this.page = Math.min(this.totalPages, this.page + 1);
                // this.$emit('pageUp', this.page);
                // this.$emit('setPage', this.page);
            }
        },
        setPage() {
            this.page = Math.max(Math.min(this.totalPages, this.page), 1);
            this.$emit('setPage', this.page);
        }
    },
    components: {
    },
    mounted: function() {
        window.addEventListener('keydown', handleKeyDown.bind(null, this));
    },
    beforeDestroy: function() {
        window.removeEventListener('keydown', handleKeyDown.bind(null, this));
    }
};

export default ProjectPagination;
</script>

<style>
.page-number-container {
    display: inline-block;
    padding: 8px;
    font-size: 17px;
    font-weight: 100;
    white-space: nowrap;
}

.current-page-input {
    min-width: 50px;
    width: 60px;
    text-align: center;
    font-size: 17px;
    font-weight: 100;
}

</style>


// WEBPACK FOOTER //
// pagination.vue?575270c8